import { BottomBanner } from '@chiroup/components/BottomBanner';
import { NotFound } from '@chiroup/components/NotFound';
import { useScript } from '@chiroup/hooks/useScript';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Container from './components/Container';

const PAY_JS_URL = import.meta.env.VITE_PAY_JS_URL as string;

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

const queryClient = new QueryClient();

function App() {
  const scriptStatus = useScript(PAY_JS_URL, {
    removeOnUnmount: false,
  });

  useEffect(() => {
    if (scriptStatus === 'ready') {
      // Monkey patch the payJS object to update the addEventListner function
      (window as any).usaepay.PaymentCard.prototype.addEventListener = function (
        eventType: any,
        response: any
      ) {
        function messageListener(event: any) {
          // Query the iframe element fresh on each message event to avoid stale references
          const paymentCardiFrame = document.getElementById('paymentCardIFrame');

          // Check if the iframe exists and has a contentWindow before accessing it
          if (paymentCardiFrame && event.source === (paymentCardiFrame as any).contentWindow) {
            const msg = event.data.split('::');

            if (msg[0] === eventType) {
              response(msg[1]);
            }
          }
        }

        // Add the event listener
        window.addEventListener('message', messageListener);

        // Cleanup: Remove the event listener when the component unmounts
        return function cleanup() {
          window.removeEventListener('message', messageListener);
        };
      };
    } else if (scriptStatus === 'error') {
      // Handle script loading error here if needed.
      console.error('Failed to load useepay script.');
    }
  }, [scriptStatus]);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SentryRoutes>
          <Route path="/:path/*" element={<Container />} />
          <Route path="*" element={<NotFound />} />
        </SentryRoutes>
      </BrowserRouter>
      {import.meta.env.VITE_STAGE === 'sandbox' && (
        <BottomBanner message="You are in sandbox mode. Do not use real data." />
      )}
    </QueryClientProvider>
  );
}

export default App;
